module.exports = __webpack_public_path__ + "img/calendar.4d5fe424.svg";